import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingSpinner = () => {
  return (
    <div className="loading-spinner">
      <Loader2 className="spinner" size={40} />
    </div>
  );
};

export default LoadingSpinner;
